import { useTranslation } from 'react-i18next'
import { PlaceholderPage } from '@/shared/components/PlaceholderPage.tsx'

export function MatrixPage() {
  const { t } = useTranslation()
  return <PlaceholderPage title={t('nav.matrix')} description={t('pages.matrix.description')} />
}
